module.exports = __webpack_public_path__ + "img/medal2.685f7aaa.png";